(function () {
	'use strict';

	angular.module('qbePortal').directive('qbPhoneNumberValidation', function () {
		
		return {
			require: 'ngModel',
			restrict: '',
			link: function (scope, elm, attrs, ctrl) {
				
				ctrl.$validators.pattern = function(modelValue, viewValue) {

					//Polyfill code for the "startswith" to be use in IE *Can be move in a startup where the JS executes
					if (!String.prototype.startsWith) {
						String.prototype.startsWith = function(searchString, position) {
							position = position || 0;
							return this.indexOf(searchString, position) === position;
						};
					}		

					if (ctrl.$isEmpty(modelValue)) {
						// consider empty models to be valid
						return true;
					}else{
						var validPhone = false;

						if(viewValue.length >= 8){
							validPhone = true;
						}

						// Starts with 13 and is 6 digits long
						// Starts with 1300 and is 10 digits long
						if(viewValue.startsWith("13")){
							if(viewValue.startsWith("1300")){
								validPhone = viewValue.length === 10 || viewValue.length === 6;
							}else{
								validPhone = viewValue.length === 6;
							}
						}

						// Starts with (0_) followed by 8 digits (where _ is 1-9), and is a minimum of 10 digits long
						// This should account for international numbers as well as local Australian numbers "0011"
						if(viewValue.startsWith("0")){
							if(viewValue.startsWith("0011")){
								validPhone = viewValue.length === 10;
							}else{
								if(viewValue[1] >= 1 && viewValue[1] <= 9){
									validPhone = viewValue.length === 10;
								}
							}
						}

						// Starts with +61 followed by 9 digits
						if(viewValue.startsWith("+")){
							validPhone = false;
							if(viewValue.startsWith("+61")){
								validPhone = viewValue.length === 12;
							}
						}

						if(viewValue.indexOf('+') > 0 || (viewValue.match(/\+/g)||[]).length > 1){
							validPhone = false;
						}

						return validPhone;
					}
				}
			}
		};
	});
})();
